@if (currentStep === 1 && !showDialog) {
} @else if (currentStep === 2) {
<app-backgrop>
	<div
		class="flex flex-col items-center justify-center md:justify-between md:pt-[134px] md:pb-15 h-full w-[1200px] max-w-full px-4">
		<app-title class="text-white mb-8">
			Выбери билет
		</app-title>
		<div class="flex flex-col gap-2 gap-y-10 md:flex-row justify-between w-full items-center relative">
			<picture>
				<source srcset="./assets-compressed/categories/payment/tickets/1.webp" type="image/webp">
				<img src="./assets-compressed/categories/payment/tickets/1.png"
					class="cursor-pointer w-[536px] hover:w-[625px] relative hover:z-2 rounded-2xl overflow-hidden hover:shadow-(--custom-bottom-shadow6) hover:-rotate-3 transition-all duration-300"
					(pointerover)="playHover()" (click)="selectTicket(1)">
			</picture>
			<picture>
				<source srcset="./assets-compressed/categories/payment/tickets/2.webp" type="image/webp">
				<img src="./assets-compressed/categories/payment/tickets/2.png"
					class="cursor-pointer w-[536px] hover:w-[625px] relative hover:z-2 rounded-2xl overflow-hidden hover:shadow-(--custom-bottom-shadow5) hover:-rotate-3 transition-all duration-300"
					(pointerover)="playHover()" (click)="selectTicket(2)">
			</picture>
		</div>
		<div
			class="absolute md:static  md:translate-x-1 bottom-10 left-1/2 transform -translate-x-1/2 text-xs/[110%] md:text-[22px] text-center w-full px-4 text-white ">
			<span class="opacity-60">Выбирая билет ты соглашаешься с </span><span
				class="cursor-pointer opacity-60 hover:opacity-100 underline" (click)="openPolicy()">политикой
				конфиденциальности</span><span class="opacity-60"> и </span><span
				class="cursor-pointer opacity-60 hover:opacity-100 underline" (click)="openAgreement()">публичной офертой</span></div>
	</div>
</app-backgrop>
} @else if (currentStep && currentStep >= 3 && currentStep < 5) { <app-backgrop>
	<app-dialog class="max-w-9/10 w-150">
		<div class="flex flex-col items-center">
			<app-title class="text-center">Вход</app-title>

			<!-- Табы переключения между Телефон и Почта -->
			<div class="flex w-full mt-4 mb-2 md:mt-6 md:mb-4">
				<button type="button"
					class="flex-1 py-3 text-center text-base md:text-xl font-medium transition-all duration-200"
					[class.hidden]="currentStep === 4 && authType === 'email'"
					[class.text-(--custom-color-1)]="authType === 'phone'" [class.cursor-pointer]="authType !== 'phone'"
					[class.border-b-2]="authType === 'phone'" [class.border-b-1]="authType !== 'phone'"
					[class.border-(--main-color)]="authType === 'phone'" [class.border-(--gray-color)]="authType !== 'phone'"
					[class.text-(--custom-color-4)]="authType !== 'phone'"
					[class.hover:text-(--custom-color-1)]="authType !== 'phone'" (click)="switchAuthType('phone')">
					Телефон
				</button>
				<button type="button"
					class="flex-1 py-3 text-center text-base md:text-xl font-medium transition-all duration-200"
					[class.hidden]="currentStep === 4 && authType !== 'email'"
					[class.text-(--custom-color-1)]="authType === 'email'" [class.cursor-pointer]="authType === 'phone'"
					[class.border-b-2]="authType === 'email'" [class.border-b-1]="authType !== 'email'"
					[class.border-(--main-color)]="authType === 'email'" [class.border-(--gray-color)]="authType !== 'email'"
					[class.text-(--custom-color-4)]="authType !== 'email'"
					[class.hover:text-(--custom-color-1)]="authType !== 'email'" (click)="switchAuthType('email')">
					Почта
				</button>
			</div>

			<!-- Подпись в зависимости от типа -->
			<div class="text-center text-base md:text-xl text-(--custom-color-1) mb-2" [class.hidden]="currentStep === 4">
				@if (authType === 'phone') {
				Введите&nbsp;номер&nbsp;телефона
				} @else {
				Введите адрес электронной почты
				}
			</div>

			@if (currentStep === 3) {
			<!-- Шаг 1: Ввод телефона или email -->

			<!-- Поле телефона -->
			@if (authType === 'phone') {
			<input
				class="h-12 bg-(--custom-color-14) rounded-md w-full px-4 placeholder-(--custom-color-4) focus:outline-none focus:ring-2 focus:ring-(--custom-color-1) mb-4"
				placeholder="+7 123 456 78 90" type="tel" id="phone" [formControl]="phone" (input)="onPhoneInput($event)"
				maxlength="15">
			}

			<!-- Поле email -->
			@if (authType === 'email') {
			<input
				class="h-12 bg-(--custom-color-14) rounded-md w-full px-4 placeholder-(--custom-color-4) focus:outline-none focus:ring-2 focus:ring-(--custom-color-1) mb-4"
				placeholder="example@gmail.com" type="email" id="email" [formControl]="email" autocomplete="email">
			}

			<!-- Ошибка валидации -->
			@if (hasError) {
			<app-text-simple class="text-left text-(--custom-color-16) w-full pl-4 mb-4">
				{{ errorText }}
			</app-text-simple>
			}


			<app-text-simple class="text-(--custom-color-4) text-left mb-1 md:mb-4">
				<!-- <span class="text-xs inline-block">Продолжая, вы соглашаетесь с
					<span class="cursor-pointer underline hover:underline" (click)="openPolicy()">Политикой конфидициальности</span>
					и
					<span class="cursor-pointer underline hover:underline" (click)="openAgreement()">условиями использования сервиса</span>
				</span> -->
				<label class="flex items-start gap-4 cursor-pointer mb-1 md:mb-2 text-[12px]/[14px] md:text-base/[18px]" for="acceptTerms">
					<input
						type="checkbox"
						id="acceptTerms"
						[(ngModel)]="acceptTerms"
						class="peer sr-only"
					/>
					<div class="mt-1 size-4 shrink-0 rounded-[4px] border-2 border-[#BFBFBF] text-black focus:ring-0 acceptTerms" >
						<svg viewBox="0 0 20 20" class="hidden size-3" fill="none">
							<path
								d="M4 10L8 14L16 6"
								stroke="white"
								stroke-width="2.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</div>

					<span>
						Я принимаю
						<span class="underline" (click)="$event.preventDefault(); $event.stopPropagation(); openPolicy()">
							Пользовательское соглашение
						</span>
						 и 
						
						<span class="underline" (click)="$event.preventDefault(); $event.stopPropagation();openAgreement()">
							Политику обработки персональных данных
						</span>. 
						Если мне не исполнилось 18 лет, я использую Платформу с согласия родителя (законного представителя).
					</span>
				</label>
			</app-text-simple>
			
			<!-- Кнопка отправки кода -->
			@if (!isWaiting) {
				<app-button [disabled]="!acceptTerms || isSendCodeDisabled" class="h-[40px] sm:h-[unset] mb-4 md:mb-8" [disabledColor]="'black'" 
					(click)="sendCode()">
					Получить код
				</app-button>
			} @else {
				<app-button [disabled]="true" class="h-[40px] sm:h-[unset] mb-4 md:mb-8" [disabledColor]="'black'">
					<div class="flex items-center">
						Подтвердите на телефоне...
					</div>
				</app-button>
			}
			
			} @else {
			<!-- Шаг 2: Ввод кода подтверждения -->


			<!-- Показать куда отправлен код -->
			<app-text-simple class="text-center text-(--custom-color-1) w-full mb-2">
				@if (authType === 'phone') {
				<strong></strong><br><br>
				Код отправлен на номер {{ getMaskedPhone() }}
				} @else {
				Код отправлен на {{ email.value }}
				}
				<br>
				<span class="text-xs md:text-base">Время действия кода ограничено</span>
			</app-text-simple>

			<!-- Поле ввода кода -->
			<input
				class="h-12 bg-(--custom-color-14) rounded-md w-full px-4 placeholder-(--custom-color-4) focus:outline-none focus:ring-2 focus:ring-(--custom-color-1) mb-4 text-center text-2xl tracking-widest"
				[placeholder]="isOtpMode ? '— — — —' : '— — — — — —'" type="text" id="verification-code" [formControl]="code" maxlength="6"
				inputmode="numeric" autocomplete="one-time-code">

			@if (hasErrorCode) {
			<app-text-simple class="text-left text-(--custom-color-16) w-full pl-4 mb-4">
				{{ errorText }}
			</app-text-simple>
			}

			@if (showNote) {
			<app-text-simple class="text-center text-(--custom-color-15) w-full pl-4 -mt-3 mb-4">
				<span class="text-xs md:text-base">
					@if (authType === 'phone') {
					Код отправлен. Проверьте SMS.
					} @else {
					Код отправлен. Проверьте почту.
					}
				</span>
			</app-text-simple>
			}

			<!-- Таймер повторной отправки -->
			<div class="text-center mb-4">
				@if (resendTimer > 0) {
				<span class="text-(--custom-color-15) text-sm">
					Отправить код повторно через {{ resendTimer }} сек.
				</span>
				} @else {
				<span
					class="font-(family-name:--default-font-family2) cursor-pointer text-(--custom-color-15) font-normal text-sm md:text-xl/[110%] underline active:text-(--custom-color-15-1) hover:text-(--custom-color-1) transition-colors"
					(click)="sendCodeAgain()">
					Отправить код повторно
				</span>
				}
			</div>

			<app-button class="mb-6" (click)="confirm(isOtpMode)">Войти</app-button>

			<span
				class="font-(family-name:--default-font-family2) cursor-pointer text-(--custom-color-15) font-normal text-sm md:text-xl/[110%] underline active:text-(--custom-color-15-1) hover:text-(--custom-color-1) transition-colors mb-4"
				(click)="prevStep()">
				@if (authType === 'phone') {
				Изменить номер/способ входа
				} @else {
				Изменить почту/способ входа
				}
			</span>

			
		
			<app-text-simple class="text-(--custom-color-15) text-center">
				<span class="text-xs inline-block">Продолжая, вы соглашаетесь с
					<span class="cursor-pointer underline" (click)="openPolicy()">Политикой конфидициальности</span>
					и
					<span class="cursor-pointer underline" (click)="openAgreement()">условиями использования сервиса</span>
				</span>
			</app-text-simple>
			}
		</div>
	</app-dialog>
	</app-backgrop>
	}
	<app-backgrop [class.hidden]="!showPaymentForm">
		<app-dialog class="max-w-9/10  w-150" [disableLoadSound]="true">
			<div id="payment-form" class=" max-h-[85dvh] overflow-y-auto"></div>
		</app-dialog>
	</app-backgrop>
	@if (showSuccessPayment) {
	<app-backgrop>
		<app-dialog class="flex md:min-h-[376px] w-[560px] max-w-9/10 p-2">
			<div class="flex flex-col items-center mb-5 sm:mb-7 md:mb-10">
				<app-title class="text-(--custom-color-1)">Успешная&nbsp;оплата</app-title>
			</div>
			<div class="block w-[345px] max-w-full m-auto text-(--custom-color-4) text-center">
				<app-text-simple class="">Теперь ты можешь вернуться в игру.</app-text-simple>
			</div>
			<div class="flex justify-center mt-8 sm:mt-12 md:mt-17">
				<app-button [disabledColor]="'black'" (click)="showFinishPhrase()">
					В игру
				</app-button>
			</div>
		</app-dialog>
	</app-backgrop>
	}
	@if (showLoader) {
	<app-backgrop>
		<div class="flex flex-col items-center">
			<div class="loader-2 w-12 h-12 border-4 border-transparent border-t-(--main-color) rounded-full animate-spin">
			</div>

			<div
				class="text-white mt-6 px-8 py-4 rounded-md text-center font-(family-name:--default-font-family2) font-light text-xs sm:text-sm md:text-[22px]/8">
				Загрузка дополнительных ресурсов...
			</div>

		</div>
	</app-backgrop>
	}
@if (isWaiting) {
	<app-backgrop>
		<div class="flex flex-col items-center">
			<div class="loader-2 w-12 h-12 border-4 border-transparent border-t-(--main-color) rounded-full animate-spin">
			</div>

			<div
				class="text-white mt-6 px-8 py-4 rounded-md text-center font-(family-name:--default-font-family2) font-light text-xs sm:text-sm md:text-[22px]/8">
				Ожидаем подтверждения входа…
			</div>

		</div>
	</app-backgrop>
	}